"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminInstructorLocationsController = /** @class */ (function () {
    function AdminInstructorLocationsController($state, $stateParams, UsersModel, FlashService, instructor, school, instructorLocations) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.school = school;
        this.user = instructor;
        this.center = {
            lat: this.school.address.lat,
            lng: this.school.address.lng,
            zoom: 34
        };
        this.instructorId = $stateParams.instructorId;
        this.locations = instructorLocations;
        this.location = this.locations[0];
        this.loading = false;
    }
    AdminInstructorLocationsController.prototype.getMatchingZones = function (location) {
        var results = [];
        var uniqueZoneIds = new Set(this.user.zones.map(function (zone) { return zone.id; }));
        location.zones.forEach(function (zone) {
            if (uniqueZoneIds.has(zone.id)) {
                results.push(zone);
            }
        });
        return Array.from(new Set(results));
    };
    AdminInstructorLocationsController.prototype.setSectorPopover = function (zone, location) {
        this.zone = zone;
        this.sectors = this.getMatchingSectors(zone, location);
    };
    AdminInstructorLocationsController.prototype.getMatchingSectors = function (zone, location) {
        var results = [];
        var sectors = location.zones.map(function (zone) { return zone.zoneparts; }).flat();
        var uniqueUserSectorIds = new Set(this.user.zoneparts.map(function (sector) { return sector.id; }));
        sectors.forEach(function (sector) {
            if (uniqueUserSectorIds.has(sector.id) && sector.zone_id === zone.id) {
                results.push(sector);
            }
        });
        return Array.from(new Set(results.map(function (sector) { return sector.id; })))
            .map(function (id) { return results.find(function (sector) { return sector.id === id; }); });
    };
    AdminInstructorLocationsController.prototype.removeLocation = function (id) {
        var _this = this;
        var data = {
            'user_id': this.$stateParams.instructorId,
            'location_id': id
        };
        this.UsersModel.unattachInstructorLocation(data).then(function (response) {
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.$state.go('drivecoach.admin.instructors.view', { 'instructorId': _this.$stateParams.instructorId });
        });
    };
    return AdminInstructorLocationsController;
}());
AdminInstructorLocationsController.$inject = ['$state', '$stateParams', 'UsersModel', 'FlashService', 'instructor', 'school', 'instructorLocations'];
exports.default = AdminInstructorLocationsController;
